export default {
  "CONTENT": {
    "HOMEPAGE": {
      "HEADER_LINK_TEXT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Return to Mastercard Developers"])},
      "HEADING": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unified Checkout Solutions"])},
      "DESCRIPTION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrate with Unified Checkout Solutions for fast, secure payments"])},
      "MTF": {
        "HEADING": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sandbox environment"])},
        "DESCRIPTION_LINE_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Build and test your integration in a test environment."])},
        "ACTION_TEXT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start testing"])}
      },
      "PROD": {
        "HEADING": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Production environment"])},
        "DESCRIPTION_LINE_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onboard, launch and manage your production environment."])},
        "ACTION_TEXT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage Production"])}
      }
    }
  }
}